module.exports = __webpack_public_path__ + "static/media/align-left.79f1062a.svg";